import { atom } from 'jotai';

export const NcwIsElementNotSwipingAtom = atom(true);
